import styled from 'styled-components';

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 50;
`;

export const ModalContainer = styled.div`
  background-color: #FFFFFF;
  border-radius: 8px;
  padding: 24px;
  max-width: 400px;
  width: 90%;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.10), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  position: relative;
  border: 1px solid #E2E8F0;
`;

export const CloseButton = styled.button`
  position: absolute;
  top: 12px;
  right: 12px;
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;
  color: #6B7280;
  &:hover {
    color: #374151;
  }
`;

export const IconContainer = styled.div<{ bgColor: string }>`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${({ bgColor }) => bgColor};
  box-shadow: 0 0 0 5px #E2E8F0;
`;

export const Title = styled.h2`
  font-size: 18px;
  font-weight: 600;
  color: #111827;
  text-align: left;
  margin: 16px 0 6px 0;
  font-family: sans-serif;
`;

export const Description = styled.p`
  font-size: 14px;
  color: #64748B;
  text-align: left;
  margin: 0 0 16px 0;
  line-height: 1.5;
  font-family: sans-serif;
`;

export const SelectContainer = styled.div`
  width: 100%;
  position: relative;
  margin-bottom: 16px;
`;

export const Select = styled.select`
  width: 100%;
  padding: 10px 12px;
  border: 1px solid #D1D5DB;
  border-radius: 8px;
  font-size: 14px;
  color: #374151;
  background-color: #FFFFFF;
  cursor: pointer;
  appearance: none;
  font-family: sans-serif;
  &:focus {
    outline: none;
    border-color: #3B82F6;
    box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.2);
  }
`;

export const SelectArrow = styled.div`
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  pointer-events: none;
  color: #6B7280;
`;

export const ButtonsContainer = styled.div<{ hasEscapeButton?: boolean }>`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: ${({ hasEscapeButton }) => hasEscapeButton ? 'space-between' : 'flex-end'};
  gap: 8px;
`;

export const SelectButton = styled.button<{ bgColor: string; disabled?: boolean }>`
  padding: 10px 16px;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  color: #FFFFFF;
  background-color: ${({ bgColor, disabled }) => disabled ? '#9CA3AF' : bgColor};
  border: none;
  cursor: ${({ disabled }) => disabled ? 'not-allowed' : 'pointer'};
  font-family: sans-serif;
  transition: opacity 0.2s;
  &:hover:not(:disabled) {
    opacity: 0.9;
  }
`;

export const EscapeButton = styled.button<{ buttonColor: string }>`
  padding: 10px 16px;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  color: ${({ buttonColor }) => buttonColor};
  background-color: transparent;
  border: none;
  cursor: pointer;
  font-family: sans-serif;
  transition: background-color 0.2s;

  &:hover {
    background-color: rgba(0, 0, 0, 0.05);
  }
`;